import React, { Component } from 'react';
import HeaderColumn from '../components/HeaderColumnComponent';
import A12Y_CONST from '../common/a12yConst';

class MaintenanceScreen extends Component {
  constructor(props) {
    super(props);
    window.document.title = "Maintenance - Advocord";
  }

  render() {
    return (
      <div className="bgCol" style={{ minHeight: '100vh' }}>
        <style>
          {`
            @keyframes spinGear {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            @keyframes spinGearReverse {
              0% { transform: rotate(360deg); }
              100% { transform: rotate(0deg); }
            }
            @keyframes pulseShadow {
              0% { box-shadow: 0 10px 40px rgba(0, 150, 199, 0.08); }
              50% { box-shadow: 0 15px 50px rgba(0, 150, 199, 0.16); }
              100% { box-shadow: 0 10px 40px rgba(0, 150, 199, 0.08); }
            }
            @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>

        <HeaderColumn props={this.props} />
        <div className="top topRelativeCol">
          <div className="container">
            <div className="master">
              <div className="" >
                <div className="imgRightSignCol onBoardingFlow" style={{ width: '100%', float: 'none', display: 'flex', justifyContent: 'center' }}>
                  
                  {/* Expanded width of the card container */}
                  <div className="signInFormBox" style={{ 
                    maxWidth: '720px', 
                    width: '100%', 
                    
                    padding: '50px 40px',
                    borderRadius: '16px',
                    boxSizing: 'border-box'
                  }}>
                    <div className="myAccountTabFullWidth" style={{width:'100%'}}>
                      <div className="signColCenter fullWidth" style={{ textAlign: 'center', maxWidth: '720px', paddingLeft: '20px', paddingRight:'20px', paddingBottom:'50px' }}>
                        
                        {/* Premium SVG Gear Illustration */}
                        <div style={{ position: 'relative', width: '160px', height: '140px', margin: '0 auto 10px auto' }}>
                          {/* Large Gear */}
                          <svg 
                            style={{ 
                              position: 'absolute', 
                              top: '10px', 
                              left: '15px', 
                              width: '90px', 
                              height: '90px', 
                              animation: 'spinGear 20s linear infinite',
                              filter: 'drop-shadow(0 4px 10px rgba(0, 150, 199, 0.15))'
                            }} 
                            viewBox="0 0 100 100" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path 
                              d="M50 30C38.95 30 30 38.95 30 50C30 61.05 38.95 70 50 70C61.05 70 70 61.05 70 50C70 38.95 61.05 30 50 30ZM50 60C44.48 60 40 55.52 40 50C40 44.48 44.48 40 50 40C55.52 40 60 44.48 60 50C60 55.52 55.52 60 50 60Z" 
                              fill="#0096C7" 
                            />
                            <path 
                              d="M50 0L44.5 10H55.5L50 0ZM90 50L80 44.5V55.5L90 50ZM50 100L55.5 90H44.5L50 100ZM10 50L20 55.5V44.5L10 50ZM21.7 21.7L31 27.2L26 17.5L21.7 21.7ZM78.3 78.3L69 72.8L74 82.5L78.3 78.3ZM78.3 21.7L74 17.5L69 27.2L78.3 21.7ZM21.7 78.3L26 82.5L31 72.8L21.7 78.3Z" 
                              fill="#0096C7" 
                            />
                          </svg>

                          {/* Small Secondary Gear */}
                          <svg 
                            style={{ 
                              position: 'absolute', 
                              bottom: '15px', 
                              right: '20px', 
                              width: '60px', 
                              height: '60px', 
                              animation: 'spinGearReverse 12s linear infinite',
                              filter: 'drop-shadow(0 4px 8px rgba(0, 119, 182, 0.15))'
                            }} 
                            viewBox="0 0 100 100" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path 
                              d="M50 30C38.95 30 30 38.95 30 50C30 61.05 38.95 70 50 70C61.05 70 70 61.05 70 50C70 38.95 61.05 30 50 30ZM50 60C44.48 60 40 55.52 40 50C40 44.48 44.48 40 50 40C55.52 40 60 44.48 60 50C60 55.52 55.52 60 50 60Z" 
                              fill="#0077B6" 
                            />
                            <path 
                              d="M50 0L44.5 10H55.5L50 0ZM90 50L80 44.5V55.5L90 50ZM50 100L55.5 90H44.5L50 100ZM10 50L20 55.5V44.5L10 50ZM21.7 21.7L31 27.2L26 17.5L21.7 21.7ZM78.3 78.3L69 72.8L74 82.5L78.3 78.3ZM78.3 21.7L74 17.5L69 27.2L78.3 21.7ZM21.7 78.3L26 82.5L31 72.8L21.7 78.3Z" 
                              fill="#0077B6" 
                            />
                          </svg>
                        </div>
                        
                        {/* Title text */}
                        <h3 className="title" style={{ 
                          fontSize: '28px', 
                          fontWeight: '600', 
                          color: '#0d1b2a', 
                          margin: '0 0 5px 0',
                          letterSpacing: '-0.5px'
                        }}>
                          Application Under Maintenance
                        </h3>
                        
                        {/* Centered descriptive text */}
                        <p style={{ 
                          color: '#5c677d', 
                          fontSize: '19px', 
                          lineHeight: '1.7', 
                          margin: '0 auto',
                          maxWidth: '610px',
                          textAlign: 'center',
                          fontWeight: '400'
                        }}>
                          We're making things better. Our website will be back shortly.
                        </p>

                      </div>
                    </div>
                    <div className="allRightReserveText" style={{justifyContent:'center'}}>
                      <span className="allRightReserveCol"> {A12Y_CONST.MESSAGE.Advocord}</span>  
                      <a target="blank" href={A12Y_CONST.TEXT.PRIVACY_POLICY_URL} className="signBottomLink">{A12Y_CONST.LABEL.SINGUP_PRIVACY_POLICY}</a> 
                      <span>{A12Y_CONST.LABEL.AND}</span> 
                      <a target="blank" href={A12Y_CONST.TEXT.TERMS_OF_SERVICE_URL} className="signBottomLink marginRightNone">{A12Y_CONST.LABEL.TERMS_OF_SERVICE}</a>.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MaintenanceScreen;
